// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:02:12

export default {
  "id": "cop-simulator",
  "slug": "cop-simulator",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/38a011ec30b9476796e3e452576b16fa-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/38a011ec30b9476796e3e452576b16fa/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cop Simulator",
      "description": "Cop Simulator is an exciting and dynamic gaming experience that immerses you in the world of a lawman with unlimited possibilities. In this game you will take on the role of a cop, where you are given complete freedom of action.",
      "instructions": "Controls on the desktop - WASD for movement, Mouse for viewing, Space for jumping, C for crouching, F for interacting with cars.  Control on a mobile device - touch/swipe.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "car",
        "city",
        "cop",
        "police",
        "thief"
      ]
    },
    "zh-CN": {
      "title": "警察模拟器",
      "description": "警察模拟器是一款令人兴奋且充满活力的游戏体验，让你沉浸在一个具有无限可能性的执法者世界中。在这款游戏中，你将扮演一名警察的角色，享有完全的行动自由。",
      "instructions": "桌面控制 - WASD键用于移动，鼠标用于观察，空格键用于跳跃，C键用于蹲下，F键用于与汽车互动。移动设备控制 - 触摸/滑动。",
      "genres": [
        "模拟"
      ],
      "tags": [
        "汽车",
        "城市",
        "警察",
        "警方",
        "小偷"
      ]
    },
    "zh-TW": {
      "title": "警察模擬器",
      "description": "Cop Simulator 是一個刺激多變的遊戲體驗，讓你沉浸於無限可能的警官世界。在這款遊戲中，你將扮演一名警察，擁有完全行動自由。",
      "instructions": "桌面上的控制 - WASD 鍵用於移動，滑鼠用於觀看，空格鍵用於跳躍，C 鍵用於蹲下，F 鍵用於與車輛互動。移動裝置上的控制 - 觸控/滑動。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "車輛",
        "城市",
        "警察",
        "警方",
        "盜賊"
      ]
    },
    "zh-HK": {
      "title": "警察模擬器",
      "description": "Cop Simulator 是一個令人興奮及多變的遊戲體驗，讓你深入一個擁有無限可能性的法官世界。在這款遊戲中，你將扮演警察的角色，並獲得完全的行動自由。",
      "instructions": "桌面上操作 - WASD用於移動，滑鼠用於觀看，空格用於跳躍，C用於蹲下，F用於與車輛互動。移動裝置上的操作 - 觸碰/滑動。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "車",
        "城",
        "警",
        "警察",
        "盜匪"
      ]
    },
    "ja": {
      "title": "コップ・シミュレーター",
      "description": "コップ・シミュレーターは、興奮とダイナミズムに満ちたゲーム体験で、無限の可能性を持つ警官の世界に没頭させます。このゲームでは、警察官としての役割を演じ、完全な行動自由が与えられます。",
      "instructions": "デスクトップでの操作 - WASDで移動、マウスで視点操作、スペースでジャンプ、Cでしゃがみ、Fで車との対話。モバイルデバイスでの操作 - タッチ/スワイプ。",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "車",
        "街",
        "警官",
        "警察",
        "泥棒"
      ]
    },
    "ko": {
      "title": "코프 시뮬레이터",
      "description": "Cop Simulator은 흥미롭고 동적인 게임 경험으로, 무한한 가능성을 가진 법무관 세계로 당신을 푹 빠뜨립니다. 이 게임에서는 경찰의 역할을 맡게 되며, 완전한 행동 자유를 제공받습니다.",
      "instructions": "데스크톱에서의 조작 - WASD로 이동, 마우스로 시야 조절, 공간바로 점프, C로蹲曙, F로 차와 상호작용. 모바일 장치에서의 조작 - 터치/스웨이프.",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "자동차",
        "도시",
        "경찰",
        "경찰청",
        "도둑"
      ]
    },
    "fr": {
      "title": "Simulateur de Police",
      "description": "Cop Simulator est une expérience de jeu captivante et dynamique qui vous plonge dans le monde d'un officier de police avec des possibilités illimitées. Dans ce jeu, vous incarnez un policier, où vous bénéficiez d'une totale liberté d'action.",
      "instructions": "Contrôles sur le bureau - WASD pour se déplacer, souris pour afficher, Espace pour sauter, C pour se prosterner, F pour interagir avec les voitures. Contrôle sur un appareil mobile - toucher / glisser.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "car",
        "ville",
        "policier",
        "police",
        "voleur"
      ]
    }
  }
};
